<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar class="scroll-area" :settings="psSettings">
      <ul class="nav">
        <li v-for="(item, index) in navItems" :key="index">
          <b-link :to="item.url" class="nav-link">
            <font-awesome-icon :icon="['fas', item.icon]" class="nav-icon" />
            {{ item.name }}
          </b-link>
        </li>
      </ul>
    </VuePerfectScrollbar>
  </nav>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'SidebarNav',
  components: {
    VuePerfectScrollbar
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    }
  }
}
</script>

<style scoped lang="css">
.scroll-area {
  position: absolute;
  height: 100%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/layoutComponent/SidebarNav.vue